import {getStatusClass} from '../../common/helper/transaction-status.component.js';
import React from 'react';

export const merchantsColumns = (expanded, transferAmount, changeStatus, deleteMerchant, updateBankingPartner, payinPartners = [], payoutPartners = [], navigateTo, canTransferMerchant, editingCell, setEditingCell) => {
  const getPartnerLabel = (partnerId, partnersList) => {
    if (!partnerId && partnerId !== 0) return 'Not Set';
    const partner = partnersList.find(p => Number(p.value) === Number(partnerId));
    return partner ? partner.label : 'Not Set';
  };

  return[
    {
      name: 'Full Name',
      cell: row => <div className="custom-cell-merchant_name">{row.merchant_detail.merchant_name}</div>,

      sortable: true,
    },
    {
      name: 'Commison Group',
      selector: row => row.merchant_detail.comm_grp_name,
      sortable: true,
    },
    {
      name: 'Phone',
      selector: row => row.merchant_detail.phone_number,
      sortable: true,
    },
    {
      name: 'Email',
      cell: row => <div className="custom-cell-email_address"> {row.merchant_detail.email_address.length > 15
        ? row.merchant_detail.email_address.slice(0, 15) + "..."
        : row.merchant_detail.email_address}</div>,
      sortable: true,
    },
    {
      name: 'Wallet',
      selector: row =>  row.balances ? '₹' + row.balances.pay_in_balance : '₹0',
      sortable: true,
    },
    {
      name: 'Holdings',
      selector: row =>  row.balances ? '₹' + row.balances.blocked_amount:'₹0',
      sortable: true,
    },
    {
      name: 'Payin Partner',
      cell: row => {
        const isEditing = editingCell?.merchantId === row.merchant_detail.merchant_id && editingCell?.field === 'payin_partner';

        if (isEditing) {
          return (
            <select
              className="form-select form-select-sm"
              style={{ fontSize: '12px', minWidth: '110px' }}
              value={row.banking_partner?.payin_partner || ''}
              onChange={(e) => {
                updateBankingPartner(row.merchant_detail.merchant_id, 'payin_partner', e.target.value, row);
                setEditingCell(null);
              }}
              onBlur={() => setEditingCell(null)}
              autoFocus
            >
              <option value="">Select</option>
              {payinPartners.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          );
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ fontSize: '12px' }}>
              {getPartnerLabel(row.banking_partner?.payin_partner, payinPartners)}
            </span>
            <i
              className="fa fa-pencil"
              style={{ cursor: 'pointer', fontSize: '11px', color: '#007bff' }}
              onClick={() => setEditingCell({ merchantId: row.merchant_detail.merchant_id, field: 'payin_partner' })}
            />
          </div>
        );
      },
    },
    {
      name: 'Payout Partner',
      cell: row => {
        const isEditing = editingCell?.merchantId === row.merchant_detail.merchant_id && editingCell?.field === 'payout_partner';

        if (isEditing) {
          return (
            <select
              className="form-select form-select-sm"
              style={{ fontSize: '12px', minWidth: '110px' }}
              value={row.banking_partner?.payout_partner || ''}
              onChange={(e) => {
                updateBankingPartner(row.merchant_detail.merchant_id, 'payout_partner', e.target.value, row);
                setEditingCell(null);
              }}
              onBlur={() => setEditingCell(null)}
              autoFocus
            >
              <option value="">Select</option>
              {payoutPartners.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          );
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ fontSize: '12px' }}>
              {getPartnerLabel(row.banking_partner?.payout_partner, payoutPartners)}
            </span>
            <i
              className="fa fa-pencil"
              style={{ cursor: 'pointer', fontSize: '11px', color: '#007bff' }}
              onClick={() => setEditingCell({ merchantId: row.merchant_detail.merchant_id, field: 'payout_partner' })}
            />
          </div>
        );
      },
    },
    {
      name: "Status",
      button: true,
      selector: row =>  row.merchant_detail.status,
    
      cell: row =>
      <>
      <div  className={`badge badge-pill ${getStatusClass(row.merchant_detail.status)} font-size-12`} style={{ backgroundColor: row.merchant_detail.merchant_id && !!expanded[row.merchant_detail.merchant_id] ? 'white' : '' }}>{row.merchant_detail.status}</div>
      </>
      // cell: row =>
      //  <>
      //     <span className="mgh">
      //       <img style={{width: '15px'}} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
      //     </span>
      //     </>
   
    },
    ...(canTransferMerchant ? [{
      name: "Transfer",
      button: true,
      cell: row => <>
      <span className={`mgh ${row.merchant_detail.status === 'Rejected' ||  row.merchant_detail.status === 'Suspended' || row.merchant_detail.status==='Initiated' ? 'disable' : ''}`}>
        <img style={{'width':'15px', 'cursor': 'pointer'}} onClick={() => transferAmount(row)} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
        </span>
      </>
    }] : []),
    
    {
      name: "Actions",
      button: true,
      style: row => ({ zIndex:0 }),
      cell: row =>
       <>
             <a className="fview tooltip" style={{'cursor':'pointer'}}  onClick={() => navigateTo('viewMerchant','view-merchant', row.merchant_detail.merchant_id)}>
         <i className="fa fa-eye" style={{ color:  row.merchant_detail.merchant_id && !!expanded[ row.merchant_detail.merchant_id] ? 'white' : 'black' }}/>
          <span className="tooltiptext">View</span>
        </a>
            <a className="flock tooltip"style={{'cursor':'pointer'}}>
            <i className={row.merchant_detail.status !== 'Active' ? 'fa fa-unlock' : 'fa fa-lock'} onClick={() => changeStatus(row)} style={{ color: row.merchant_detail.merchant_id && !!expanded[row.merchant_detail.merchant_id] ? 'white' : 'black' }}/>
            <span className="tooltiptext">
              <>
                {row.merchant_detail.status !== 'Active' ? (
                  'Lock'
                ) : (
                  'UnLock' // Or whatever you want to show if the status is 'Active'
                )}
              </>
    
            </span>
          </a>
          <a className={`fedit tooltip ${ row.merchant_detail.status === 'Suspended' ? 'disable' : ''}`} style={{'cursor':'pointer'}}  onClick={() => navigateTo('editMerchant','edit-merchant', row.merchant_detail.merchant_id)}>
            <i  className={`fa ${ row.merchant_detail.status === 'Suspended'? 'fa-edit disable' : 'fa-edit'}`}   style={{ color: row.merchant_detail.merchant_id && !!expanded[row.merchant_detail.merchant_id] ? 'white' : 'black' }}/>
            <span className="tooltiptext">Edit</span>
          </a>
          <a className="ftrash tooltip" style={{'cursor':'pointer'}}>
            <i className="fa fa-trash"  onClick={() => deleteMerchant(row)} style={{ color: row.merchant_detail.merchant_id && !!expanded[row.merchant_detail.merchant_id] ? 'white' : 'black' }}/>
            <span className="tooltiptext">Delete</span>
          </a>
          <a className="fell tooltip"  style={{'paddingRight':'25px', 'cursor':'pointer'}}>
            <i className="fa fa-ellipsis-v"   style={{ color: row.merchant_detail.merchant_id && !!expanded[row.merchant_detail.merchant_id] ? 'white' : 'black' }} aria-hidden="true" />
            <span className="tooltiptext">More</span>
          </a>
          </>
   
    }
  ];

}
